import { useEffect, useRef } from 'react';
export var useMount = function (func) { return useEffect(func, []); };
export var useUnmount = function (func) { return useEffect(function () { return func; }, []); };
export var useUpdate = function (func, dependencies) {
    var isMounted = useRef(false);
    useEffect(function () {
        if (isMounted.current) {
            func();
        }
        else {
            isMounted.current = true;
        }
    }, dependencies);
};
export var useEffectWithPrevious = function (func, dependencies) {
    var previousDependencies = useRef(dependencies);
    useEffect(function () {
        func(previousDependencies.current);
        previousDependencies.current = dependencies;
    }, dependencies);
};
